import React from "react";
import { UserComment } from "../../redux/types";

const CommentTagCard = (props: { comment: UserComment }) => {
  const { comment } = props;
  return (
    <div className="flex flex-wrap pt-4">
      {comment.tag.map((t, index) => (
        <div
          key={index}
          className="flex items-center px-2 py-1 mb-2 ml-2 border-solid rounded-md w-fit border-1 border-pkc-secondary"
        >
          {t.is_positive ? (
            <i className="ml-2 far fa-plus-circle text-pkc-primary" />
          ) : (
            <i className="ml-2 far fa-minus-circle text-pkc-disable" />
          )}
          <span className="text-sm">{t.title}</span>
        </div>
      ))}
    </div>
  );
};

export default CommentTagCard;
